import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import qs from 'qs';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import useDetectSize from '@hooks/useDetectSize';
import { Page, MobileContainer, DesktopContainer } from '@containers/layout';
import { Box, IconButton, Heading, Button } from '@components/common';
import {
  CleanRate,
  CleanEdit,
  CalendarView,
  CleanReschedule
} from '@containers/cleans';
import history from '@utils/history';

import CleansActions, { CleansSelectors } from '@redux/CleansRedux';

const ContainerView = styled(MobileContainer)`
  align-self: flex-start;
  align-items: stretch;

  @media screen and (max-width: 767px) {
    justify-content: flex-start;
  }

  @media screen and (min-width: 1024px) {
    padding-top: 0px;
  }
`;

function CleanPage(props) {
  const {
    match: { params, url, isExact },
    location: { search },
    clearClean,
    loadClean,
    currentClean
  } = props;

  const { bookingId } = params;
  if (!bookingId) {
    goBack();
    return null;
  }

  useEffect(() => {
    loadClean(bookingId, search);
    return () => {
      clearClean();
    };
  }, [bookingId]);

  const isMobile = useDetectSize();

  const goBack = () => {
    history.goBack();
  };

  const renderBackButton = () => {
    return (
      <IconButton
        onClick={goBack}
        name="back"
        width={16}
        height={16}
        title="Back"
      />
    );
  };

  const renderCleanView = () => {
    if (!currentClean) {
      return null;
    }

    const { status } = currentClean;
    const isCompleted = status === 'cleaned';

    const qsParams = qs.parse(search);
    let initialRate = qsParams['?rating'] || qsParams['rating'];
    if (!isNaN(initialRate)) {
      initialRate = parseInt(initialRate);
    } else {
      initialRate = undefined;
    }

    if (isCompleted) {
      return <CleanRate initialRate={initialRate} />;
    }

    return (
      <Switch>
        <Route exact path={`${url}/`} component={CleanEdit} />
        <Route exact path={`${url}/edit`} component={CleanReschedule} />
      </Switch>
    );
  };

  const renderHeader = () => {
    const { formattedDate } = currentClean || {};
    return (
      <Box
        display={['none', 'flex']}
        flexDirection="row"
        justifyContent="space-between"
        mb={4}
      >
        <Heading py={0} my={0}>
          {formattedDate}
        </Heading>
        <Button
          type="button"
          size="small"
          variant="secondary"
          onClick={() => {
            if (isExact) {
              history.push('/');
            } else {
              history.goBack();
            }
          }}
        >
          {isExact ? 'Done' : 'Cancel'}
        </Button>
      </Box>
    );
  };

  return (
    <Page renderHeaderLeftButtons={renderBackButton}>
      <DesktopContainer>
        {!isMobile && (
          <CalendarView
            flex={1}
            onItemClick={item => {
              const { bookingID: bookingId } = item;
              history.push(`/bookings/${bookingId}`);
            }}
          />
        )}
        <ContainerView>
          {renderHeader()}
          {renderCleanView()}
        </ContainerView>
      </DesktopContainer>
    </Page>
  );
}

CleanPage.propTypes = {
  match: PropTypes.object,
  currentClean: PropTypes.object,
  clearClean: PropTypes.func,
  loadClean: PropTypes.func,
  location: PropTypes.object
};

const mapStatesToProps = state => ({
  currentClean: CleansSelectors.selectCurrentClean(state)
});

const mapDispatchToProps = dispatch => ({
  loadClean: (bookingId, searchParams) =>
    dispatch(
      CleansActions.setMyCleanDetailLoadRequest(bookingId, searchParams)
    ),
  clearClean: () => dispatch(CleansActions.setCurrentClean(null))
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(CleanPage);
